// extracted by mini-css-extract-plugin
module.exports = {"input":"_2PVqq4gMjhK8OCM_aLQJt6","search-icon":"mFkaZNlTHsqhx_x4OeBLd","clear-icon":"_2wU1NztG-9fqZIa625SX_k"};